import { LEGACY_HUB_REDIRECT_PATHS } from './loyaltyHubLegacyRedirects';

export const LOYALTY_HUB_BASE_PATH = {
  mcom: '/loyalty/starrewards',
  bcom: '/loyallist/accountsummary',
};

// Base URL for parsing relative hrefs only; not used for network requests.
const RELATIVE_URL_BASE = 'https://example.invalid';

function parseNavUrl(href) {
  try {
    return new URL(href, RELATIVE_URL_BASE);
  } catch {
    return null;
  }
}

export function isLoyaltyHubNavUrl(href, brand) {
  if (!href) {
    return false;
  }

  const hubPath = LOYALTY_HUB_BASE_PATH[brand];
  const url = parseNavUrl(href);

  if (!url) {
    return href.startsWith(hubPath);
  }

  if (url.pathname === hubPath) {
    return true;
  }

  return brand === 'bcom' && LEGACY_HUB_REDIRECT_PATHS.includes(url.pathname);
}

export function getLoyaltyHubNavQuery(href) {
  const url = new URL(href, RELATIVE_URL_BASE);
  return Object.fromEntries(url.searchParams.entries());
}

export function resolveLoyaltyHubNavTarget(href, brand) {
  if (!isLoyaltyHubNavUrl(href, brand)) {
    return null;
  }

  return {
    path: LOYALTY_HUB_BASE_PATH[brand],
    query: getLoyaltyHubNavQuery(href),
  };
}
